<template>
  <form @submit.prevent="update" novalidate autocomplete="off">
    <div class="has-background-white has-shadow px-lg py-md mb-xxs">
      <div class="columns">
        <div class="column">
          <div class="">
            <div class="mb-md">
              <!-- Content Loaded -->
              <div v-if="!loading && client !== null">
                <!-- Name -->
                <div class="mb-lg">
                  <div class="columns">
                    <div class="column is-half">
                      <b-field
                        label="Client Name"
                        :type="('name' in errors) ? 'is-danger' : ''"
                        :message="('name' in errors) ? errors['name'][0] : ''"
                        expanded>
                          <b-input
                            autocomplete="off"
                            type="text"
                            v-model="client.name"
                            @input="isDirty=1"
                          ></b-input>
                      </b-field>
                    </div>
                    <div class="column is-half">
                      <b-field
                        label="Quickbooks Client #"
                        :type="('identifier' in errors) ? 'is-danger' : ''"
                        :message="('identifier' in errors) ? errors['identifier'][0] : ''"
                        expanded>
                          <b-input
                            autocomplete="off"
                            type="text"
                            v-model="client.identifier"
                            @input="isDirty=1"
                          ></b-input>
                      </b-field>
                    </div>
                  </div>
                </div>
                <!-- Billing Address -->
                <div class="mb-lg">
                  <b-field
                    label="Billing Address"
                    :type="('street1' in errors) ? 'is-danger' : ''"
                    :message="('street1' in errors) ? errors['street1'][0] : ''"
                    expanded>
                      <b-input
                        autocomplete="off"
                        type="text"
                        name="street1"
                        v-model="client.billing_street1"
                        @input="isDirty = 1"
                      ></b-input>
                  </b-field>
                  <b-field
                    :type="('street2' in errors) ? 'is-danger' : ''"
                    :message="('street2' in errors) ? errors['street2'][0] : ''"
                    expanded>
                      <b-input
                        autocomplete="off"
                        type="text"
                        name="street2"
                        v-model="client.billing_street2"
                        placeholder="Suite, etc (optional)"
                        @input="isDirty = 1"
                      ></b-input>
                  </b-field>
                  <b-field
                    :type="('street3' in errors) ? 'is-danger' : ''"
                    :message="('street3' in errors) ? errors['street2'][0] : ''"
                    expanded>
                      <b-input
                        autocomplete="off"
                        type="text"
                        name="street2"
                        v-model="client.billing_street3"
                        placeholder="Attn: (optional)"
                        @input="isDirty = 1"
                      ></b-input>
                  </b-field>
                </div>
                <!-- City -->
                <div class="mb-md">
                  <b-field
                    label="City"
                    :type="('city' in errors) ? 'is-danger' : ''"
                    :message="('city' in errors) ? errors['city'][0] : ''"
                    expanded>
                      <b-input
                        autocomplete="off"
                        type="text"
                        name="city"
                        v-model="client.billing_city"
                        @input="isDirty = 1"
                      ></b-input>
                  </b-field>
                </div>
                <!-- Country, Province, Zip -->
                <div class="columns">
                  <div class="column is-one-third">
                    <b-field
                      label="Country"
                      :type="('country' in errors) ? 'is-danger' : ''"
                      :message="('country' in errors) ? errors['country'][0] : ''"
                        expanded>
                        <b-select
                          v-model="client.billing_country_code"
                          name="country"
                          placeholder="Select Country"
                          @input="isDirty = 1"
                          expanded>
                          <option value="US">United States</option>
                          <option value="CA">Canada</option>
                          <option value="UK">United Kingdom</option>
                        </b-select>
                    </b-field>
                  </div>
                  <div class="column is-one-third">
                    <b-field
                      label="State / Province"
                      :type="('province' in errors) ? 'is-danger' : ''"
                      :message="('province' in errors) ? errors['province'][0] : ''"
                      expanded>
                        <b-input
                          maxlength="2"
                          autocomplete="off"
                          type="text"
                          name="province"
                          v-model="client.billing_province"
                          @input="isDirty = 1"
                        ></b-input>
                    </b-field>
                  </div>
                  <div class="column is-one-third">
                    <b-field
                      label="Postal Code"
                      :type="('postal_code' in errors) ? 'is-danger' : ''"
                      :message="('postal_code' in errors) ? errors['postal_code'][0] : ''"
                      expanded>
                        <b-input
                          maxlength="12"
                          autocomplete="off"
                          type="text"
                          name="postalCode"
                          v-model="client.billing_postal_code"
                          @input="isDirty = 1"
                        ></b-input>
                    </b-field>
                  </div>
                </div>
              </div>
              <!-- Loading Skeleton -->
              <div v-else>
                <div class="mb-lg">
                  <b-skeleton width="20%" height="10" :animated="true"></b-skeleton>
                  <b-skeleton width="80%" height="30" :animated="true"></b-skeleton>
                </div>
                <div class="mb-lg">
                  <b-skeleton width="20%" height="10" :animated="true"></b-skeleton>
                  <b-skeleton width="80%" height="30" :animated="true"></b-skeleton>
                  <b-skeleton width="80%" height="30" :animated="true"></b-skeleton>
                  <b-skeleton width="80%" height="30" :animated="true"></b-skeleton>
                </div>
                <div class="mb-lg">
                  <b-skeleton width="20%" height="10" :animated="true"></b-skeleton>
                  <b-skeleton width="80%" height="30" :animated="true"></b-skeleton>
                </div>
                <div class="mb-lg">
                  <b-skeleton width="20%" height="10" :animated="true"></b-skeleton>
                  <b-skeleton width="80%" height="30" :animated="true"></b-skeleton>
                  <b-skeleton width="80%" height="30" :animated="true"></b-skeleton>
                </div>
              </div>
            </div>
          </div>
          <div class="border-t">
            <div class="columns is-vcentered is-marginless">
              <div class="column">
                <div class="px-sm has-text-grey-light">
                  <i v-if="isDirty">Click 'Update' to save your changes</i>
                </div>
              </div>
              <div class="column is-narrow">
                <div class="px-sm">
                  <b-button native-type="submit" type="is-primary rounded-lg" :disabled="saving || !isDirty">Update</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['api']),
    endpoint () {
      return this.api.route + '/clients/' + this.$route.params.id
    },
    json () {
      return {
        name: this.client.name,
        identifier: this.client.identifier,
        billing_street1: this.client.billing_street1,
        billing_street2: this.client.billing_street2,
        billing_street3: this.client.billing_street3,
        billing_city: this.client.billing_city,
        billing_province: this.client.billing_province,
        billing_postal_code: this.client.billing_postal_code,
        billing_country_code: this.client.billing_country_code
      }
    }
  },
  data () {
    return {
      isDirty: false,
      loading: true,
      saving: false,
      client: null,
      errors: []
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$http.get(this.endpoint).then(response => {
        this.client = response.data
        this.loading = false
      })
    },
    update () {
      this.saving = true
      this.$http.patch(this.endpoint, this.json).then(response => {
        this.client = response.data
        this.saving = false
        this.$buefy.toast.open({ type: 'is-success', message: 'Client updated!' })
        this.isDirty = false
        this.errors = []
      }).catch(error => {
        this.errors = error.response.data.errors
        this.$buefy.toast.open({ type: 'is-danger', message: 'There were problems with your input. Please review and try again.' })
        this.saving = false
        this.isDirty = false
      })
    }
  },
  mounted () {
    this.load()
  }
}
</script>
